var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { useAuthProvider, useLucidSdk } from '#context';
import { toWorkspaceViewModels } from '#models';
import { WorkspacesKeyFactory } from '../../query-key-factories';
export const useUserWorkspaces = ({ refetchInterval } = {
    refetchInterval: false,
}) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const { currentUser } = useAuthProvider();
    const query = useQuery({
        queryKey: WorkspacesKeyFactory.all(),
        queryFn: () => lucidSdk
            .workspacesManagement()
            .listWorkspaces({ includePending: true }),
        enabled: Boolean(currentUser?.emailVerified),
        networkMode: 'always',
        refetchInterval: refetchInterval,
        select: toWorkspaceViewModels,
    });
    return { query };
};
_react_refresh_temp_1(useUserWorkspaces, "wEg9DMWQ/CI4rGOcHGIhupr8WvQ=", false, () => [useLucidSdk, useAuthProvider, useQuery]);
